import { useContext } from "react";
import { ValidationContext } from "./validation-context-props.ts";

const useValidationContext = () => {
    const context = useContext(ValidationContext);
    if (!context) {
        throw new Error('Must be defined in ValidationContext');
    }
    return context;
}

export default useValidationContext;